export const AGENT_ALLOCATION_LABELS = {
  DEFAULT: 'Default',
  REALLOCATED: 'Reallocated',
  UNSET: 'Unset'
} as const;

export type AgentAllocationLabel = (typeof AGENT_ALLOCATION_LABELS)[keyof typeof AGENT_ALLOCATION_LABELS];
